import React, { Component } from "react";
import { StaticQuery, graphql } from "gatsby";
import Img from "gatsby-image";
import Slider from "react-slick";
import PropTypes from "prop-types";
import chevron from "../images/feature/next.png";

import carWiseOfferConfig from "./configs/carWiseOfferConfig";

import "../css/feature.less";
import "../css/globalRules.less";

const FeatureImage = (props) => {
  return (
    <StaticQuery
      query={graphql`
        query {
          taigun_0: file(relativePath: { eq: "feature/taigun/01.png" }) {
            childImageSharp {
              fluid(maxWidth: 400) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          taigun_1: file(relativePath: { eq: "feature/taigun/02.png" }) {
            childImageSharp {
              fluid(maxWidth: 400) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          taigun_2: file(relativePath: { eq: "feature/taigun/03.png" }) {
            childImageSharp {
              fluid(maxWidth: 400) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          taigun_3: file(relativePath: { eq: "feature/taigun/04.png" }) {
            childImageSharp {
              fluid(maxWidth: 400) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          taigun_4: file(relativePath: { eq: "feature/taigun/05.png" }) {
            childImageSharp {
              fluid(maxWidth: 400) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          taigun_5: file(relativePath: { eq: "feature/taigun/06.png" }) {
            childImageSharp {
              fluid(maxWidth: 400) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          virtus_0: file(relativePath: { eq: "feature/virtus/01.png" }) {
            childImageSharp {
              fluid(maxWidth: 400) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          virtus_1: file(relativePath: { eq: "feature/virtus/02.png" }) {
            childImageSharp {
              fluid(maxWidth: 400) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          virtus_2: file(relativePath: { eq: "feature/virtus/03.png" }) {
            childImageSharp {
              fluid(maxWidth: 400) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          virtus_3: file(relativePath: { eq: "feature/virtus/04.png" }) {
            childImageSharp {
              fluid(maxWidth: 400) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          virtus_4: file(relativePath: { eq: "feature/virtus/05.png" }) {
            childImageSharp {
              fluid(maxWidth: 400) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          virtus_5: file(relativePath: { eq: "feature/virtus/06.png" }) {
            childImageSharp {
              fluid(maxWidth: 400) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          tiguan_0: file(relativePath: { eq: "feature/tiguan/01.png" }) {
            childImageSharp {
              fluid(maxWidth: 400) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          tiguan_1: file(relativePath: { eq: "feature/tiguan/02.png" }) {
            childImageSharp {
              fluid(maxWidth: 400) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          tiguan_2: file(relativePath: { eq: "feature/tiguan/03.png" }) {
            childImageSharp {
              fluid(maxWidth: 400) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          tiguan_3: file(relativePath: { eq: "feature/tiguan/04.png" }) {
            childImageSharp {
              fluid(maxWidth: 400) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          tiguan_4: file(relativePath: { eq: "feature/tiguan/05.png" }) {
            childImageSharp {
              fluid(maxWidth: 400) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          tiguan_5: file(relativePath: { eq: "feature/tiguan/06.png" }) {
            childImageSharp {
              fluid(maxWidth: 400) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      `}
      render={(data) => {
        let imagesObject = {};
        Object.keys(data).forEach((key) => {
          imagesObject[key] = data[key]?.childImageSharp.fluid;
        });
        return <Img fluid={imagesObject[props.feature]} alt="Image" />;
      }}
    />
  );
};

FeatureImage.propTypes = {
  feature: PropTypes.string.isRequired,
};

export default class FeatureSlider extends Component {
  render() {
    const settings = {
      dots: false,
      pauseOnHover: false,
      pauseOnFocus: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 3000,
      centerMode: false,
      arrows: true,
      infinite: false,
      nextArrow: (
        <div>
          <div className="next-slick-arrow">
            {/* <img src={chevron} alt="nextArrow" /> */}
            <svg
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="#fff"
            >
              <path d="M19 12a1.73 1.73 0 0 1-.47 1.18l-9.1 9.32-.93-.94 9.09-9.32a.34.34 0 0 0 0-.48L8.5 2.44l.93-.94 9.1 9.32A1.7 1.7 0 0 1 19 12Z"></path>
            </svg>
          </div>
        </div>
      ),
      prevArrow: (
        <div>
          <div className="prev-slick-arrow">
            {/* <img src={chevron} alt="rightArrow" className="rotateimg180" /> */}
            <svg
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="#fff"
              className="rotateimg180"
            >
              <path d="M19 12a1.73 1.73 0 0 1-.47 1.18l-9.1 9.32-.93-.94 9.09-9.32a.34.34 0 0 0 0-.48L8.5 2.44l.93-.94 9.1 9.32A1.7 1.7 0 0 1 19 12Z"></path>
            </svg>
          </div>
        </div>
      ),
      responsive: [
        {
          breakpoint: 1400,
          settings: {
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },

        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: false,
            centerPadding: "0",
          },
        },
      ],
    };

    const featureListCar =
      carWiseOfferConfig[this.props.carName]?.carFeatureList;
    return (
      <div className="container-fluid features-sec py-md-5 mt-5 px-0 overflow-hidden position-relative">
        <div className="features-slider container px-0">
          <div className="main-heading">Features</div>
          <Slider {...settings} className="pt-md-5 pt-4">
            {featureListCar?.map((item, index) => {
              const { description, featureHeading } = item;
              const featureListKey = "" + this.props.carName + "_" + index;
              return (
                <div className="mySlides">
                  <FeatureImage feature={featureListKey} />
                  <div className="feature-content-block">
                    <div
                      className="featureimage-heading"
                      dangerouslySetInnerHTML={{
                        __html: featureHeading,
                      }}
                    />
                    <p className="featureimage-desc">{description}</p>
                  </div>
                </div>
              );
            })}
          </Slider>
        </div>
      </div>
    );
  }
}
